import {MailOrdersListWrapper} from './mail-order-list/MailOrdersList'
import {useIntl} from 'react-intl'
import {AzPageHeader} from '../../components/AzPageHeader'

const MailOrdersPage = () => {
  const intl = useIntl()

  return (
    <>
      <AzPageHeader
        title={intl.formatMessage({id: 'MAIL_ORDER_PAGE.TITLE'})}
        subtitle={intl.formatMessage({id: 'MAIL_ORDER_PAGE.BREADCRUMB'})}
      />
      <MailOrdersListWrapper />
    </>
  )
}

export default MailOrdersPage
